import TourSection from '../ui/TourSection';
import FamilyTour from './FamilyTour';
import PageWrapper from '../layout/PageWrapper';
import TextBoxImage from '../ui/TextBoxImage';

export default function Home() {
  return (
    <PageWrapper>
      <TourSection />
      <div className="bg-white h-8"></div>
      <FamilyTour />
      <TextBoxImage />
    </PageWrapper>
  );
}